import t from '@jetshop/intl';
import React from 'react';
import { Header, Matches } from './SearchPage';
import SearchTerm from './SearchTerm';

const EmptySearchResults = ({ term, result }) => {
  return (
    <div>
      <Header>
        <Matches>
          {t.rich('No results for <Term />', {
            Term: () => <SearchTerm key="term">"{term}"</SearchTerm>
          })}
        </Matches>
      </Header>
    </div>
  );
};

export default EmptySearchResults;
